export default "__VITE_ASSET__CD1ub9KA__"